import { render, staticRenderFns } from "./TopTracksCard.vue?vue&type=template&id=5baf2425"
import script from "./TopTracksCard.vue?vue&type=script&lang=js"
export * from "./TopTracksCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports